import { xget, xhttp } from "../Fetchv2.js";
import { PGSchema } from "../schemas/pg.schema.js";

export class Ads {
	/** @GET /pages/:uid/ads
	 * Obtiene todos los anuncios de la página
	 */
	async getAllAds(pgid: string, params: { take?: number; skip?: number }, token: string) {
		let p = { params: btoa(JSON.stringify(params)) };
		let response = await xget<{ ads: PGSchema.ads[] }>(`/pages/${pgid}/ads`, { params: p }, { headers: { "app-token": token } });
		return response;
	}

	/** @POST /pages/:uid/ads
	 * Crea un nuevo anuncio
	 */
	async createAd(pgid: string, body: Omit<PGSchema.ads, "id" | "pgid" | "created_at" | "updated_at" | "created_by">, token: string) {
		let response = await xhttp<{ ad: PGSchema.ads }>(`/pages/${pgid}/ads`, "POST", body, { headers: { "app-token": token } });
		return response;
	}

	/** @GET /pages/:uid/ads/:id
	 * Obtiene un anuncio específico
	 */
	async getAd(pgid: string, id: string, token: string) {
		let response = await xget<{ ad: PGSchema.ads }>(`/pages/${pgid}/ads/${id}`, {}, { headers: { "app-token": token } });
		return response;
	}

	/** @PUT /pages/:uid/ads/:id
	 * Edita un anuncio existente
	 */
	async editAd(pgid: string, id: string, body: Partial<Omit<PGSchema.ads, "id" | "pgid" | "created_at" | "updated_at" | "created_by">>, token: string) {
		let response = await xhttp<{ updated: number }>(`/pages/${pgid}/ads/${id}`, "PUT", body, { headers: { "app-token": token } });
		return response;
	}

	/** @DELETE /pages/:uid/ads/:id
	 * Borra un anuncio
	 */
	async deleteAd(pgid: string, id: string, token: string) {
		let response = await xhttp<{ deleted: PGSchema.ads }>(`/pages/${pgid}/ads/${id}`, "DELETE", {}, { headers: { "app-token": token } });
		return response;
	}
}
